<template>
  <div id="js-header" class="header">
    <div class="l-header">
      <div class="l-header-inner">
        <div class="l-header-content">
          <div class="l-header-content-inner">
            <header-logo></header-logo>

            <header-navigation></header-navigation>
          </div>
        </div>

        <js-navigation-children-about></js-navigation-children-about>

        <js-navigation-children-ir></js-navigation-children-ir>
      </div>
    </div>

    <js-navigation-button></js-navigation-button>
  </div>
</template>

<script>
import HeaderLogo from "@/components/molecules/HeaderLogo";
import HeaderNavigation from "@/components/molecules/HeaderNavigation";
import JsNavigationChildrenAbout from "@/components/molecules/JsNavigationChildrenAbout";
import JsNavigationChildrenIr from "@/components/molecules/JsNavigationChildrenIr";
import JsNavigationButton from "@/components/molecules/JsNavigationButton";

export default {
  components: {
    HeaderLogo,
    HeaderNavigation,
    JsNavigationChildrenAbout,
    JsNavigationChildrenIr,
    JsNavigationButton,
  },
};
</script>
